import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getJwt } from '@/shared/lib/betterAuth/get-jwt'
import { getPetClaimDocuments } from '@/services/claims.services'
import {
  CLAIMS_QUERY_KEYS,
  CACHE_STALE_TIME,
  CACHE_GC_TIME,
  QUERY_NETWORK_MODE,
} from '@/shared/constants/cache'
import type { ClaimDocument } from '@/shared/types/global.types'

export function usePetClaimDocuments(claimId: string) {
  const { i18n } = useTranslation()

  return useQuery<ClaimDocument[]>({
    queryKey: CLAIMS_QUERY_KEYS.petDocuments(claimId),
    queryFn: async () => {
      const token = await getJwt()
      if (!token) throw new Error('No JWT token')
      return getPetClaimDocuments(token, i18n.language, claimId)
    },
    enabled: !!claimId,
    staleTime: CACHE_STALE_TIME,
    gcTime: CACHE_GC_TIME,
    networkMode: QUERY_NETWORK_MODE,
  })
}
